// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.entity-link {
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.entity-link__title {
  font-family: var(--g-text-subheader-font-family);
  font-weight: var(--g-text-subheader-font-weight);
  font-size: var(--g-text-subheader-1-font-size);
  line-height: var(--g-text-subheader-1-line-height);
  margin-bottom: var(--g-spacing-1);
}
.entity-link__row {
  height: 34px;
  padding-left: 0;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/EntityLink/EntityLink.scss","webpack://./node_modules/@gravity-ui/uikit/styles/mixins.scss"],"names":[],"mappings":"AAEA;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AADJ;AAGI;ECuNA,gDAAA;EACA,gDAAA;EACA,8CAAA;EACA,kDAAA;EDxNI,iCAAA;AAER;AACI;EACI,YAAA;EACA,eAAA;AACR","sourcesContent":[".entity-link {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n.entity-link__title {\n  font-family: var(--g-text-subheader-font-family);\n  font-weight: var(--g-text-subheader-font-weight);\n  font-size: var(--g-text-subheader-1-font-size);\n  line-height: var(--g-text-subheader-1-line-height);\n  margin-bottom: var(--g-spacing-1);\n}\n.entity-link__row {\n  height: 34px;\n  padding-left: 0;\n}",null],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
